import { render, staticRenderFns } from "./AdForm.vue?vue&type=template&id=4ddbbef3"
import script from "./AdForm.vue?vue&type=script&lang=ts"
export * from "./AdForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports